import { FC } from 'react';

import CreatePost from '../../feed/createPost/CreatePost';
import Posts from 'pages/feed/Posts';
import { EmptyState } from 'components/emptyState';
import { EmptyStateOptions, EventSources, IFeedStore } from 'types';

interface IActivitiesSection {
  isLoggedInUserProfile: boolean;
  isSeller: boolean;
  postsDetails: IFeedStore;
  isCreatePostLoading: boolean;
  getUserFeed(): void;
}

const ActivitiesSection: FC<IActivitiesSection> = ({
  isLoggedInUserProfile,
  isSeller,
  isCreatePostLoading,
  getUserFeed,
  postsDetails,
}) => {
  return (
    <div className="activities-section">
      {isLoggedInUserProfile && <CreatePost onUserClick={() => {}} isSeller={isSeller} />}
      <Posts
        shouldDisplayFeedBubbles={false}
        posts={postsDetails.list}
        hasMore={postsDetails.hasMore}
        isLoading={postsDetails.isLoading}
        selectedFeedBubble={postsDetails.selectedFeedBubble}
        mojoSource={EventSources.Profile}
        getFeed={getUserFeed}
        scrollerId="content"
        selectedChatId={null}
        shouldHideFollowButton
        emptyState={
          <div className="section">
            <EmptyState type={EmptyStateOptions.ShopActivity} />
          </div>
        }
        isCreatePostLoading={isCreatePostLoading}
      />
    </div>
  );
};

export default ActivitiesSection;
